// extracted by css-extract-rspack-plugin
export default {"span":"check-box-module__span___IC6jp checked-input-module__span___VGyT6 common-module__errorStateBorder___Xkscu","checkmark":"check-box-module__checkmark___lUwgv"};